<template>
    <v-form ref="form" autocomplete="off" @submit.prevent>
        <v-row>
            <v-col cols="12" sm="6">
                <v-text-field
                    name="nombre"
                    v-model="form.nombre"
                    label="Nombre"
                    :error="hasInputErrors('nombre')"
                    :error-messages="getInputErrors('nombre')"
                    color="secondary"
                    :rules="required"
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    name="apellido"
                    v-model="form.apellido"
                    label="Apellido"
                    :error="hasInputErrors('apellido')"
                    :error-messages="getInputErrors('apellido')"
                    color="secondary"
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    name="email"
                    v-model="form.email"
                    label="Email"
                    :error="hasInputErrors('email')"
                    :error-messages="getInputErrors('email')"
                    color="secondary"
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    name="telefono"
                    v-model="form.telefono"
                    label="Teléfono"
                    :error="hasInputErrors('telefono')"
                    :error-messages="getInputErrors('telefono')"
                    color="secondary"
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    name="comision"
                    v-model.number="form.comision"
                    :label="$t('vendedor.labels.comision')"
                    type="number"
                    min="0"
                    max="100"
                    suffix="%"
                    :error="hasInputErrors('comision')"
                    :error-messages="getInputErrors('comision')"
                    color="secondary"
                    :rules="comisionRules"
                />
            </v-col>
            <v-col cols="12" sm="6" class="d-flex align-center">
                <v-switch
                    v-model="form.activo"
                    label="Activo"
                    color="secondary"
                />
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { InputErrorsByProps, RequiredRule } from "@dracul/common-frontend";

export default {
    name: "VendedorForm",
    mixins: [InputErrorsByProps, RequiredRule],
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    computed: {
        form: {
            get() { return this.value; },
            set(val) { this.$emit("input", val); },
        },
        comisionRules() {
            return [
                v => v == null || v === '' || Number(v) >= 0 || this.$t('vendedor.validation.comisionMin'),
                v => v == null || v === '' || Number(v) <= 100 || this.$t('vendedor.validation.comisionMax'),
            ];
        },
    },
    watch: {
        form: {
            handler(newVal) { this.$emit("input", newVal); },
            deep: true,
        },
    },
    methods: {
        validate() {
            return this.$refs.form.validate();
        },
    },
};
</script>
